import Vuex from 'vuex'
import { ApiClient } from '../helpers/api-client/ApiClient'

const returnBlob = response => response.blob()

export default function store ({ state, mutations, actions, getters }) {
  return new Vuex.Store({
    state: {
      showPreloader: true,
      layout: process.env.VUE_APP_DEFAULT_LAYOUT,
      accessToken: localStorage.getItem('accessToken'),
      expiresIn: localStorage.getItem('expiresIn'),
      refreshToken: localStorage.getItem('refreshToken'),
      user: localStorage.getItem('user') ? localStorage.getItem('user') : null,
      permissions: localStorage.getItem('permissions') ? localStorage.getItem('permissions') : null,
      creationPassKind: 'all',
      configuration: [],
      transportMarks: [],
      transportModels: [],
      transportStsTypes: [],
      documentValidators: [],
      errorImages: {},
      dadataManagerName: '',
      dadataManagerPosition: '',
      otherData: null,

      ...state
    },

    mutations: {
      setState (state, { stateName, value }) {
        state[stateName] = value
      },

      setTransportMarks (state, payload) {
        state.transportMarks = payload
      },

      setTransportModels (state, payload) {
        state.transportModels = payload
      },

      setTransportStsTypes (state, payload) {
        state.transportStsTypes = payload
      },

      setDocumentValidators (state, payload) {
        state.documentValidators = payload
      },

      setConfiguration (state, payload) {
        state.configuration = payload
      },

      setShowPreloader (state, payload) {
        state.showPreloader = payload
      },

      setLayout (state, payload) {
        state.layout = payload
      },

      setAccessToken (state, payload) {
        localStorage.setItem('accessToken', payload)
        state.accessToken = payload
      },

      setExpiresIn (state, payload) {
        localStorage.setItem('expiresIn', payload)
        state.expiresIn = payload
      },

      setRefreshToken (state, payload) {
        localStorage.setItem('refreshToken', payload)
        state.refreshToken = payload
      },

      setUser (state, payload) {
        const userInfo = JSON.stringify(payload)
        localStorage.setItem('user', userInfo)
        state.user = userInfo
      },

      setPermissions (state, payload) {
        const permissions = JSON.stringify(payload)
        localStorage.setItem('permissions', permissions)
        state.permissions = permissions
      },

      setErrorImages (state, payload) {
        state.errorImages = payload
      },

      setOtherData (state, payload) {
        state.otherData = payload
      },

      ...mutations
    },

    actions: {
      showPreloader (context) {
        context.commit('setShowPreloader', true)
      },

      hidePreloader (context) {
        context.commit('setShowPreloader', false)
      },

      async fetchErrorImages(context) {
        context.commit('setErrorImages', {
          fetchGeneralFail: await fetch(String(require('@/common/assets/img/errors/fetchGeneralFail.svg'))).then(returnBlob),
          imageIsRestricted: await fetch(String(require('@/common/assets/img/errors/imageIsRestricted.svg'))).then(returnBlob),
          invalidObject: await fetch(String(require('@/common/assets/img/errors/invalidObject.svg'))).then(returnBlob),
          uppyError: await fetch(String(require('@/common/assets/img/errors/uppyError.svg'))).then(returnBlob),
          401: await fetch(String(require('@/common/assets/img/errors/401.svg'))).then(returnBlob),
          403: await fetch(String(require('@/common/assets/img/errors/403.svg'))).then(returnBlob),
          404: await fetch(String(require('@/common/assets/img/errors/404.svg'))).then(returnBlob)
        })
      },

      async authorize (context, payload) {
        context.commit('setAccessToken', payload.access_token)
        context.commit('setExpiresIn', payload.expires_in)
        context.commit('setRefreshToken', payload.refresh_token)

        const user = await ApiClient.userMe()
        context.commit('setUser', user.data.data)
        const permissions = await ApiClient.userPermissions()
        context.commit('setPermissions', permissions.data.data)
      },

      flushAuthorize (context) {
        context.commit('setAccessToken', null)
        context.commit('setExpiresIn', null)
        context.commit('setRefreshToken', null)
        context.commit('setUser', null)
        context.commit('setPermissions', null)
      },

      ...actions
    },

    getters: {
      getField: (state) => (path) => {
        return state[path];
      },

      transportMarks (state) {
        return state.transportMarks
      },

      transportModels (state) {
        return state.transportModels
      },

      transportStsTypes (state) {
        return state.transportStsTypes
      },

      configuration (state) {
        return state.configuration
      },

      documentValidators (state) {
        return state.documentValidators
      },

      showPreloader (state) {
        return state.showPreloader
      },

      layout (state) {
        return state.layout
      },

      accessToken (state) {
        return state.accessToken
      },

      expiresIn (state) {
        return state.expiresIn
      },

      refreshToken (state) {
        return state.refreshToken
      },

      user (state) {
        return JSON.parse(state.user)
      },

      permissions (state) {
        return JSON.parse(state.permissions)
      },

      isAuthorized (state) {
        return Boolean(state.accessToken)
      },

      errorImages (state) {
        return state.errorImages
      },

      ...getters
    }
  })
}
